import { render, staticRenderFns } from "./SetPasswordPage.vue?vue&type=template&id=91f19e8a&"
import script from "./SetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./SetPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports